<template>
  <div class="ant-upload-preview">
    <div class="avatatImg">
      <a-upload
          name="avatar"
          listType="picture-card"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          :customRequest="function () {}"
          @change="handleChange"
          accept="image">
        <img class="upload_img" v-if="imageUrl" :src="imageUrl" alt="avatar"/>
        <div v-else>
          <a-icon :type="loading ? 'loading' : 'plus'"/>
          <div class="ant-upload-text">上传图片</div>
        </div>
        <div
            v-if="imageUrl && !multi"
            @click="removeFile"
            class="remove-btn-wrap">
          <a-button type="danger" size="small" shape="round">clear</a-button>
        </div>
      </a-upload>
      <div class="text">
        <div>{{ avatarTextTop }}</div>
        <div>{{ avatarTextBottom }}</div>
      </div>
    </div>
    <!-- 引入裁剪组件 -->
    <CropperModal
        ref="CropperModal"
        :imgType="imgType"
        :fileName="fileName"
        :cropperMode="cropperMode"
        :serviceType="serviceType"
        @cropper-no="handleCropperClose"
        @cropper-ok="handleCropperSuccess"
    />
  </div>
</template>

<script>
import CropperModal from './CropperModal.vue';

export default {
  components: { CropperModal },
  props: {
    // 图片裁切配置
    options: {
      type: Object,
      default: function () {
        return {
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 1020, // 默认生成截图框宽度
          autoCropHeight: 480, // 默认生成截图框高度
          fixedBox: true, // 是否固定截图框大小 不允许改变
          previewsCircle: false, // 预览图是否是原圆形
          serviceType: '',
          title: '修改图片',
        };
      },
    },
    multi: {
      type: Boolean,
      default: false
    },
    onUploadSuccess: {
      type: Function
    },
    avatarTextTop: {
      type: String,
      default: '',
    },
    avatarTextBottom: {
      type: String,
      default: '图片需小于2M',
    },
    // 上传图片的大小，单位M
    imgSize: {
      type: Number,
      default: 2,
    },
    imgType: {
      type: String,
      default: '',
    },
    // 图片地址
    imageUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fileName: '', // 文件名
      loading: false,
      isStopRun: false,
      cropperMode: 'contain', // 图片渲染方式
      serviceType: '', // 存储方式 AWS S3/ALI OSS
    };
  },
  methods: {
    // 从本地选择文件
    handleChange(info) {
      this.loading = info.file.status;
      this.fileName = info.file.name;
      if (this.isStopRun) {
        return;
      }
      const { options } = this;
      this.getBase64(info.file.originFileObj, (imageUrl) => {
        const target = Object.assign({}, options, { img: imageUrl, });
        this.$refs.CropperModal.edit(target);
      });
    },
    // 上传之前 格式与大小校验
    beforeUpload(file) {
      this.$emit('avatarLoadingFn', true);
      // 获取上传图片尺寸
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result
        img.onload = () => {
          // 1、先根据图片裁剪的尺寸
          if (this.options.autoCropWidth > this.options.autoCropHeight) {
            // 2、再根据上传图片尺寸
            this.cropperMode = this.options.autoCropWidth + 'px auto'
          } else {
            if (img.width >= img.height) {
              this.cropperMode = 'auto ' + this.options.autoCropHeight + 'px'
            } else {
              this.cropperMode = this.options.autoCropWidth + 'px auto'
            }
          }
        }
      }
      return true;
    },
    // 获取服务器返回的地址
    handleCropperSuccess(data) {
      this.loading = false;
      // 如有回调, 执行回调
      if (this.onUploadSuccess) {
        this.onUploadSuccess(data);
      }
      console.log('cropperUploader, multi: ' + this.options.multi)
      console.log('cropperUploader, data: ' + data)
      if (this.multi) {
        console.log('cropperUploader,multi if judge: ' + this.options.multi)
        // this.imageUrl = data;
        // this.$emit('input', data);
      } else {
        // 将返回的数据回显
        console.log('cropperUploader,multi else judge: ' + this.options.multi)
        this.imageUrl = data;
        this.$emit('input', data);
      }
    },
    // 取消上传
    handleCropperClose() {
      this.loading = false;
    },
    getBase64(img, callback) {
      if (img) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
      }
    },
    removeFile(e) {
      e.preventDefault();
      e.stopPropagation();
      this.imageUrl = null;
      this.$emit('input', null);
    },
    created() {
      console.log(this.serviceType);
    }
  },
};
</script>

<style lang="less" scoped>
.avatar-upload-wrapper {
  height: 180px;
  width: 100%;
}

.ant-upload-preview {
  background-color: #fff;

  .avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
  }

  .ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
  }

  .upload_img {
    width: 100%;
  }

  .ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
  }
}

.ant-upload-picture-card-wrapper {
  width: auto;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.avatatImg {
  // width: 100%;
  display: flex;
  align-items: center;

  .text {
    margin-left: 20px;

    div {
      line-height: 30px !important;
      font-weight: 600;
    }
  }
}
</style>
